import { Typography, Row, Col, Space } from 'antd';
import { formatTicketNumber, maskDateForTickets } from '../../../util/utils';
import { GENERAL, TICKET } from '../../../constants/AppConstants';

import logo from "../../../assets/images/Logo-Rifas-Gran-Familia.png";
import './Ticket.css';

const { Title, Text } = Typography;

export default function Ticket(props) {
    const { data } = props;
    const url = window.location.href;


    return (
        <div className="ticket-container">
            <div className="ticket-header">
                <Row align="middle" gutter={[16, 16]}>
                    <Col span={8}>
                        <img
                            src={logo}
                            alt={GENERAL.PAGE_NAME}
                            style={{ maxHeight: "90px" }}
                        />
                    </Col>
                    <Col span={16}>
                        <Title level={4} style={{ margin: 0, textTransform: 'uppercase', color: '#222' }}>
                            {GENERAL.PAGE_NAME}
                        </Title>
                    </Col>
                </Row>
                <div style={{ textAlign: 'center', marginTop: 10 }}>
                    <div className="custom-badge badge-gold">{TICKET.LOTTO_BADGE} #{data?.lotto?.lottoNumber}</div>
                    <Title level={3} style={{ margin: '10px 0', color: '#333', textTransform: 'uppercase' }}>
                        {data?.lotto?.title}
                    </Title>
                    <Title level={3} style={{ color: '#a63429', margin: 0 }}>
                        {formatTicketNumber(data?.ticketNumber, data?.lotto?.ticketAmount)}
                    </Title>
                    {data?.subTickets?.length > 0 && data?.subTickets?.map((subTicket, index) => (
                        <Text key={index} strong style={{ color: '#a63429', fontSize: 16 }}>{index === 0 ? "" : ", "}{formatTicketNumber(subTicket?.subTicketNumber, data?.lotto?.ticketAmount)}</Text>
                    ))}
                </div>
            </div>
            <div className="ticket-divider-container">
                <div className="ticket-notch notch-left"></div>
                <div className="dashed-line"></div>
                <div className="ticket-notch notch-right"></div>
            </div>
            <div style={{ padding: '10px 30px', textAlign: 'center' }}>
                <div className="custom-badge badge-black">{TICKET.INFO_BADGE}</div>
                <Space direction="vertical" size="small" style={{ width: '100%', textAlign: 'left', marginTop: 10 }}>
                    <InfoRow label="NOMBRE:" value={data?.name ? data?.name : "-"} />
                    <InfoRow label="APELLIDO:" value={data?.lastName ? data?.lastName : "-"} />
                    <InfoRow label="ESTADO:" value={data?.state ? data?.state : "-"} />
                    <InfoRow label="STATUS:" value={data?.purchaseDate ? "PAGADO" : "NO PAGADO"} />
                    <InfoRow label="COMPRA:" value={data?.purchaseDate ? maskDateForTickets(data?.purchaseDate) : "-"} />
                    <InfoRow label="RESERVADO:" value={data?.reservationDate ? maskDateForTickets(data?.reservationDate) : "-"} />
                </Space>

                <Title level={4} style={{ marginTop: 20, marginBottom: 0, color: '#333' }}>
                    {TICKET.LUCKY_MESSAGE}
                </Title>
            </div>
            <div className="ticket-footer-curve">
                {/* <Text style={{ color: 'white', display: 'block' }}>{GENERAL.WEB_PAGE}</Text> */}
                <Text style={{ color: 'white', display: 'block' }}>{url}</Text>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontSize: 12 }}>
                    <span>{GENERAL.PLACE}</span>
                    <span>Rifas Gran Familia GDL</span>
                </div>
            </div>
        </div>
    );
};

const InfoRow = ({ label, value }) => (
    <Row gutter={8} align="middle">
        <Col span={8} style={{ textAlign: 'right' }}>
            <Text className="info-label">{label}</Text>
        </Col>
        <Col span={16}>
            <Text className="info-value">{value}</Text>
        </Col>
    </Row>
);